
// classes/ToggleBodyClass.js
class ToggleBodyClass {
  constructor(buttonElement, className, callback = null) {
    this.button = buttonElement;
    this.className = className;
    this.callback = callback;

    if (this.button) {
      this.button.addEventListener('click', () => this.toggleClass());
    }
  }

  toggleClass() {
    // Remove any existing '*-open' class from body
    document.body.classList.forEach(cls => {
      if (cls.endsWith('-open') && cls !== this.className) {
        document.body.classList.remove(cls);
      }
    });

    // Toggle the new class
    document.body.classList.toggle(this.className);

    // Execute callback if provided
    if (typeof this.callback === 'function') {
      this.callback(document.body.classList.contains(this.className));
    }
  }
}

export { ToggleBodyClass };
 